module.exports = "/_next/static/resources/wv-wide-5920b12caba3e3724b2125ef4c2d6b2c.png";